export default function initSubpanels(subpanels, prefix) {
	return (dispatch) => {
		dispatch({
			type: 'INIT_SUBPANELS',
			payload: {subpanels, prefix},
		});
	};
}